import React from 'react'
import { connect } from '@cerebral/react'
import { state, signal } from 'cerebral/tags'
import { css } from 'aphrodite'
import styles from './styles'
import { t } from '@billes/translator-client'

export function DialogComponent({
  dialog,
  onDismiss,
  onConfirm,
  setDialogCheckvalue,
  toggleDialogCheckvalue
}) {
  if (!dialog) {
    return null
  }
  const { title, content = {}, type = 'alert', checkOption } = dialog

  const container = css(
    styles.backdrop,
    dialog.content ? styles.visible : null
  )

  let contentValue = t(content.key, { ...content.params })
  contentValue = contentValue.replace(/\n/g, '<br/>')
  return (
    <div className={container}>
      <div className={css(styles.container)}>
        {dialog.title && dialog.title.key ? (
          <div className={css(styles.title)}>
            {t(title.key, title.params)}
          </div>
        ) : null}
        <div
          className={css(styles.content)}
          dangerouslySetInnerHTML={{
            __html: contentValue
          }}
        />
        {checkOption ? (
          <div className={css(styles.content)}>
            <input
              type={'checkbox'}
              checked={checkOption.value}
              onChange={e => {
                setDialogCheckvalue({ value: e.target.checked })
              }}
            />
            <span
              onClick={e => {
                toggleDialogCheckvalue()
              }}
              style={{ cursor: 'pointer' }}
            >
              {t(checkOption.title)}
            </span>
          </div>
        ) : null}
        <div className={css(styles.actions)}>
          {type === 'confirm' ? (
            <div>
              <button
                className={css(styles.button)}
                onClick={e => {
                  if (onDismiss) {
                    onDismiss()
                  }
                }}
              >
                {t('common.cancel')}
              </button>
              <button
                className={css(styles.button)}
                onClick={e => {
                  if (onConfirm) {
                    onConfirm()
                  }
                }}
              >
                {t('common.confirm')}
              </button>
            </div>
          ) : null}
          {type === 'alert' ? (
            <button
              className={css(styles.button)}
              onClick={e => {
                if (onDismiss) {
                  onDismiss()
                }
              }}
            >
              {t('common.ok')}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default connect(
  {
    dialog: state`app.dialog`,
    onDismiss: signal`app.onDismiss`,
    onConfirm: signal`app.onConfirm`,
    setDialogCheckvalue: signal`app.setDialogCheckvalue`,
    toggleDialogCheckvalue: signal`app.toggleDialogCheckvalue`
  },
  DialogComponent
)



// WEBPACK FOOTER //
// ./src/components/Common/Dialog/dialog.js